import React from "react";
import "../styles/HomeCoreValues.css";

const coreValues = [
  {
    id: 1,
    title: "Quality",
    image: "/qualities/Quality.png", 
  },
  {
    id: 2,
    title: "Service",
    image: "/qualities/Service.png", 
  },
  {
    id: 3,
    title: "Integrity",
    image: "/qualities/Integrity.png",
  },
  {
    id: 4,
    title: "Commitment",
    image: "/qualities/Commitment.png",
  },
  {
    id: 5,
    title: "Teamwork",
    image: "/qualities/Teamwork.png",
  },
  {
    id: 6,
    title: "Trust!",
    image: "/qualities/image.png",
  },
];

function HomeCoreValues() {
  return (
    <div className="core-values-section">
      <h2 className="core-values-heading">Our Core Values</h2>
      <p className="core-values-intro">
        At Laxmi Hospitality Services, our commitment to excellence is built
        upon a foundation of core values that guide every aspect of our
        operations and interactions.
      </p>

      <div className="main-circle-layout-container">
        <div className="main-circle-content">
          <p className="main-circle-text">
            Laxmi Hospitality Services is built on strong foundations.
            <br />
            Our core values drive excellence, integrity, and customer
            satisfaction.
          </p>
        </div>

        {coreValues.map((value, index) => (
          <div
            key={value.id}
            className={`small-value-circle circle-${index + 1}`}
          >
            <img
              src={value.image}
              alt={value.title + " Icon"}
              className="small-value-icon"
            />
            <span className="small-value-title">{value.title}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default HomeCoreValues;